import * as Sentry from '@sentry/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import axios from 'axios'
import airbridge from 'airbridge-web-sdk-loader'

import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import reportWebVitals from './reportWebVitals'

import { queryClient } from './utils/queryClient'

import StoreProvider from './provider/StoreProvider'

import { router } from './routes/Router'

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
})

axios.defaults.baseURL = process.env.REACT_APP_STO_API
axios.defaults.withCredentials = true

const container = document.getElementById('root')
const root = createRoot(container as HTMLElement) // createRoot(container!) if you use TypeScript

if (process.env?.REACT_APP_ABR_APP_NAME && process.env.REACT_APP_ABR_WEB_TOKEN) {
  airbridge.init({
    app: process.env.REACT_APP_ABR_APP_NAME,
    webToken: process.env.REACT_APP_ABR_WEB_TOKEN,
  })
}

root.render(
  /**
   * 잘못 사용한 생명주기 메서드 - 지원 종료된 생명주기 사용시 경고
   * 레거시 문자열 ref 사용 여부 - react 초기 버젼에 지원됨
   * findDOMNode 사용 여부 - 컴포넌트 자식 중 특정 엘리먼트를 찾는 함수
   * 예상치 못한 부작용(side effect) - render 함수를 호출해서 이전값과 비교하는 방식(렌더링 단계의 메서드를 두 번씩 호출)
   */
  // <React.StrictMode>
  <QueryClientProvider client={queryClient}>
    <StoreProvider>
      <HelmetProvider>
        <RouterProvider router={router} />
      </HelmetProvider>
    </StoreProvider>
    <ReactQueryDevtools />
  </QueryClientProvider>,
  // </React.StrictMode>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
